import * as React from "react"
import { Link } from "./library/link"

export interface FeaturedContentBlockProps {
  readonly title: string
  readonly html: string
  readonly linkTitle: string
  readonly linkUrl: string
  readonly imageUrl: string
  readonly imageUrlLarge: string
  readonly imageAlt: string
}

export const FeaturedContentBlock = (props: FeaturedContentBlockProps) => (
  <div className="featured-content-block container--lg align--center">
    <div className="featured-content-block__text">
      <header>
        <h2 className="featured-content-block__title title--l">{props.title}</h2>
      </header>

      <div className="text--styled" dangerouslySetInnerHTML={{ __html: props.html }} />

      {props.linkUrl && props.linkTitle && (
        <footer className="featured-content-block__footer">
          <Link className="button button--primary button--arrow" url={props.linkUrl}><span className="button__label">{props.linkTitle}</span></Link>
        </footer>
      )}
    </div>

    <div className="featured-content-block__media image-block__wrapper">
      <div className="featured-content-block__visual image-block__inner">
        <img
          src="/bkw/images/bkw/empty.png"
          data-src={props.imageUrl}
          data-srcset={`${props.imageUrl} 300w, ${props.imageUrlLarge} 600w`}
          alt={props.imageAlt}
          width="478"
          height="478"
          className="featured-content-block__image image-block__image lazyload"
        />
      </div>
    </div>
  </div>
)

{/* TH: Added to styleguide! */}

